import React from 'react' //{useState}
import ModalSwal from '../../modules/permisoDenegado/Modalswal'
import { useAppSelector } from '../../../redux/hooks'

//import {useState } from 'react'
const CloudSecurityMain: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
  const mostrarDatos = !ListaPermisosTenant.includes('Ctx.Monitoring.View')
  return (
    <>
      {!mostrarDatos && <iframe src="/media/cspm/report.html" width="100%" height="750px">
      </iframe>}
    </>

  )
}

export { CloudSecurityMain }
